/* eslint-disable arrow-body-style */
/* eslint-disable react/destructuring-assignment */
import React from 'react'
import { getFullFormattedDate } from '@components/Ackodrive/common/utils'
import {
  CategoryStyledTitle,
  CategoryImage,
  CategoryDate,
  CategoryDescription,
  CategoryStyledWrapper,
  CategoryContent,
  Link,
} from './styles'

const CategoryCard = props => {
  return (
    <CategoryStyledWrapper>
      <Link href={props.articleUrl}>
        <CategoryImage src={props.image} alt={props.title} />
      </Link>
      <CategoryContent>
        <Link href={props.articleUrl}>
          <CategoryStyledTitle>{props.title}</CategoryStyledTitle>
        </Link>
        <CategoryDate>Modified Date: {getFullFormattedDate(props.modifiedDate)}</CategoryDate>
        <CategoryDescription>{props.description}</CategoryDescription>
      </CategoryContent>
    </CategoryStyledWrapper>
  )
}

export default CategoryCard
